export { default as GoogleMap } from './GoogleMap'
export { default as LoadScript } from './LoadScript'
export { default as TrafficLayer } from './components/maps/TrafficLayer'
export { default as BicyclingLayer } from './components/maps/BicyclingLayer'

export { default as DrawingManager } from './components/drawing/DrawingManager'
export { default as Marker } from './components/drawing/Marker'
export { default as InfoWindow } from './components/drawing/InfoWindow'
export { default as Polyline } from './components/drawing/Polyline'
export { default as Polygon } from './components/drawing/Polygon'
export { default as Rectangle } from './components/drawing/Rectangle'
export { default as Circle } from './components/drawing/Circle'

export { default as KmlLayer } from './components/kml/KmlLayer'

export { default as OverlayView } from './components/dom/OverlayView'

export { default as FusionTablesLayer } from './components/fusion/FusionTablesLayer'

// export { default as ImageMapType } from './components/overlays/ImageMapType'
export { default as GroundOverlay } from './components/overlays/GroundOverlay'
export { default as HeatmapLayer } from './components/heatmap/HeatmapLayer'

// export { default as StreetViewPanorama } from './components/streetview/StreetViewPanorama'
// export { default as StreetViewCoverageLayer } from './components/streetview/StreetViewCoverageLayer'
// export { default as StreetViewService } from './components/streetview/StreetViewService'

export { default as DirectionsService } from './components/directions/DirectionsService'
export { default as DirectionsRenderer } from './components/directions/DirectionsRenderer'

// export { default as SearchBox } from './components/places/SearchBox'
// export { default as StandaloneSearchBox } from './components/places/StandaloneSearchBox'

// export { default as InfoBox } from './components/addons/InfoBox'
// export { default as MarkerCluster } from './components/addons/MarkerCluster'
// export { default as MarkerWithLabel } from './components/addons/MarkerWithLabel'
